import { combineReducers } from 'redux';

import i18n from '../../i18n/reducer';
import routing from '../../routing/reducer';
import ui from '../../ui/reducer';
import prizeList from '../../prizeList/reducer';
import onboarding from '../../onboarding/reducer';
import teams from '../../teams/reducer';
import games from '../../games/reducer';
import picks from '../../picks/reducer';
import players from '../../players/reducer';
import howTo from '../../howTo/reducer';
import heatStreak from '../../heatStreak/reducer';
import reminders from '../../reminders/reducer';
import offers from '../../offers/reducer';
import leaderboard from '../../leaderboard/reducer';

const config = (state = {}, action) => {
  const { resp } = action;
  switch (action.type) {
    case 'SET_SESSION_VALUE':
      return { ...state, ...resp };
    case 'SET_FETCH_CONFIG_STATUS':
      return { ...state, hasFetchedConfig: true };
    default:
      return state;
  }
};

const rootReducer = () =>
  combineReducers({
    config,
    strings: i18n,
    routing,
    ui,
    onboarding,
    teams,
    games,
    picks,
    players,
    howTo,
    prizeList,
    heatStreak,
    reminders,
    offers,
    leaderboard,
  });

export default rootReducer;
